<template>
  <div id="page-forms">

    <v-container fluid>
      <v-form
        v-model="form.valid"
        ref="contactlist"
        lazy-validation
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="First Name"
              prepend-icon="newspaper"
              name="firstName"
              v-model="form.firstName"
              required
              :rules="form.requiredfield"
            >
            </v-text-field>
          </v-flex>

          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Last Name"
              prepend-icon="newspaper"
              name="description"
              v-model="form.lastName"
              required
              :rules="form.requiredfield"
            ></v-text-field>
          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-text-field
              label="Job Title"
              prepend-icon="newspaper"
              name="description"
              v-model="form.jobTitle"
            ></v-text-field>

          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-autocomplete
               hint="Atleast 3 Characters required"          
               chips             
              flat
              placeholder="Select only suggested Business Account"
              :items="businessAccountOptions"
              v-model="form.businessAccount"
              prepend-icon="assistant"
              label="Business Account"
              color="blue"
              item-text="name"
              item-value="id"
              required
              :rules="form.requiredfield"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-autocomplete              
              hint="Atleast 3 Characters required"            
              chips              
              flat
              placeholder="Select only suggested Owner"
              :items="ownerOptions"
              v-model="form.owner"
              prepend-icon="assistant"
              label="Owner"
              color="blue"
              item-text="userName"
              item-value="userID"
              required
              :rules="form.requiredfield"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            lg3
            sm3
          >
            <v-autocomplete              
              hint="Atleast 3 Characters required"              
              chips              
              flat
              placeholder="Select only suggested Work Group"
              :items="workGroupOptions"
              v-model="form.workGroup"
              prepend-icon="assistant"
              label="Work Group"
              color="blue"
              item-text="name"
              item-value="id"
              required
              :rules="form.requiredfield"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            lg3
            sm3
          >
            <v-autocomplete              
              hint="Atleast 3 Characters required"    
              chips              
              flat
              placeholder="Select only suggested Contact Class"
              :items="contactClassOptions"
              v-model="form.contactClass"
              prepend-icon="people_outline"
              label="Contact Class"
              color="blue"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            lg3
            sm3
          >
            <v-autocomplete              
              hint="Atleast 3 Characters required"            
              chips              
              flat
              placeholder="Select only suggested Type"
              :items="typeOptions"
              v-model="form.type"
              prepend-icon="style"
              label="Type"
              color="blue"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
          <v-flex
            lg3
            sm3
          >
            <v-autocomplete
              :items="statusOptions"
              v-model="form.statusCodeId"
              prepend-icon="people_outline"
              label="Status"
              color="blue"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

      </v-form>
    </v-container>
    <v-tabs color="transparent">
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab key="#tab-1">
        <v-card-text>Details</v-card-text>
      </v-tab>
      <v-tab key="#tab-2">
        <v-card-text>Activities</v-card-text>
      </v-tab>
      <v-tab key="#tab-3">

        <v-card-text>Task</v-card-text>
      </v-tab>
      <v-tabs-items>
        <v-tab-item key="#tab-1">
          <v-card flat>
            <contact-detail ref="contactdetail"></contact-detail>
          </v-card>
        </v-tab-item>
        <v-tab-item key="#tab-2">
          <v-card flat>
            <contact-activities ref="contactactivities"></contact-activities>
          </v-card>
        </v-tab-item>
        <v-tab-item key="#tab-3">
          <v-card flat>
            <contact-cases ref="contactcases"></contact-cases>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

  </div>
</template>
 
<script>
import ContactDetail from '@/pages/contact/ContactDetail';
import ContactActivities from '@/pages/contact/ContactActivities';
import ContactCases from '@/pages/contact/ContactCases';
import VWidget from '@/components/VWidget';
export default {
  components: {
    VWidget,
    ContactDetail,
    ContactActivities,
    ContactCases
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: () => ({
    items: [
      { title: 'Add to Production Plan' },
      { title: 'Update task' },
      { title: 'Delete Order' },
      { title: 'Publish this to production' },
      { title: 'Duplicate Order...' }
    ],
    saveCard: true,
    SDateMenu: false,
    SDate: null,
    TimeMenu: false,
    Time: null,
    ownerOptions: [],
    businessAccountOptions: [
      {
        id: 1,
        name: 'Business Account 1'
      },
      {
        id: 2,
        name: 'Business Account 2'
      },
      {
        id: 3,
        name: 'Business Account 3'
      }
    ],
    // ownerOptions: [
    //   {
    //     id: 1,
    //     name: 'Owner 1'
    //   },
    //   {
    //     id: 2,
    //     name: 'Owner 2'
    //   },
    //   {
    //     id: 3,
    //     name: 'Owner 3'
    //   }
    // ],
    workGroupOptions: [
      {
        id: 1,
        name: 'Work Group 1'
      },
      {
        id: 2,
        name: 'Work Group 2'
      },
      {
        id: 3,
        name: 'Work Group 3'
      }
    ],
    contactClassOptions: [
      {
        id: 1,
        name: 'Contact Class 1'
      },
      {
        id: 2,
        name: 'Contact Class 2'
      },
      {
        id: 3,
        name: 'Contact Class 3'
      }

    ],

    statusOptions: [
      {
        id: 1,
        name: 'Active'
      },
      {
        id: 2,
        name: 'In Active'
      },
    ],

    typeOptions: [
      {
        id: 1,
        name: 'Type 1'
      },
      {
        id: 2,
        name: 'Type 2'
      },
    ],

    valid: true,
    form: {
      date: new Date().toISOString().substr(0, 10),
      loginUser: 'Arun',
      isLogin: 'yes-1',
      valid: false,
      contactID: -1,
      businessAccount: -1,
      owner: -1,
      firstName: '',
      lastName: '',
      workGroup: -1,
      contactClass: -1,
      jobTitle: '',
      status: -1,
      type: -1,
      email: '',
      phone: '',
      fax: '',
      address1: '',
      address2: '',
      city: '',
      stateID: -1,
      countryID: -1,
      postalCode: '',
      isDataPrivacy: '',
      dateOfConsent: '',
      consentExpires: '',
      contactMethod: -1,
      accountReference: '',
      parentAccount: '',
      inComingActivity: '',
      outGoingActivity: '',
      companyName: '',
      dOB: '',
      spouseName: '',
      gender: -1,
      maritalStatus: -1,
      lastAccessDate: '',
      addedByUserId: null,
      addedDate: new Date(),
      statusCodeId: 1,
      statusCode: 'Active',
      modifiedByUserId: null,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      contactActivities: [],

    }
  }),
  mounted () {
    this.$validator.localize('en', this.dictionary);
  },
  posts () {
    return getPost();
  },

  methods: {
    handleClick: e => {
      console.log(e);
    },
    submit () {
      this.$validator.validateAll();
    },
    clear () {
      this.form = {};
      this.$validator.reset();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/contact/ContactTabs.vue